export default "__VITE_ASSET__CFscGQws__"